























import LeftMenu from '@/components/left-menu'
import SearchBox from '@/components/search-box'
import Notification from '@/components/notification'
import AcceptTerms from '@/components/accept-terms'
import AltitudeControl from '@/components/altitude-control'
import MapLegend from '@/components/map-legend'
import SuperMap from '@/components/super-map'
import XcPlanner from '@/components/xc-planner'

export default {
  name: 'map-view',
  components: {
    LeftMenu,
    SearchBox,
    Notification,
    AltitudeControl,
    MapLegend,
    XcPlanner,
    SuperMap,
    AcceptTerms
  },
  props: [
    'width',
    'mapVisible'
  ],
  computed: {
    xcplanner() {
      return this.$store.state.persistent.xcplanner
    },
    needAgreement() {
      return new Date(this.$store.state.persistent.acceptedRules) < new Date(this.$store.state.time.tosDate)
    }
  },
  methods: {
    zoom(diff) {
      const mapSync = Object.assign({}, this.$store.state.runtime.mapSync)
      mapSync.zoom += diff
      this.$store.dispatch('runtime/mapSync', mapSync)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/map-view.vue